export default "__VITE_ASSET__aEUEumwq__"